import { RadioStation } from '@/types';

/** Statični fallback — isti podaci kao Strapi (aktivni streamovi). Hardcoded samo za potpuno fresh offline start. */
export const STATIONS: RadioStation[] = [
  {
    id: "sij602fukorrmvtxjh0a10tc",
    name: "Suton Radio - LIVE",
    streamUrl: "https://live.radio-suton.de/listen/suton_radio/radio.mp3",
    genre: "mix",
    description: "Glavni live stream sa Balkana - DJ-evi i hitovi 24/7",
    artwork: "https://cms.radio-suton.de/uploads/SUTON_Radio_Logo_Weiss_5ab628e48c.png",
    isActive: true,
    bitrate: 128,
    location: "Frankfurt",
    color: "linear-gradient(135deg, #D946EF 0%, #8B5CF6 50%, #2563EB 100%)",
  },
  {
    id: "c902h4189gstukuxycifdh37",
    name: "Suton Radio - 80-te Narodna",
    streamUrl: "https://live.radio-suton.de/listen/narodna_80/radio.mp3",
    genre: "narodna",
    description: "Narodna muzika 80-tih godina",
    artwork: "https://cms.radio-suton.de/uploads/favicon_radio_suton_750_8663b4362d.png",
    isActive: true,
    bitrate: 192,
    location: "Germany",
    color: "#E63946",
  },
  {
    id: "nr3iirxkqmsm8tv6070upbob",
    name: "Suton Radio - 80-te Zabavna",
    streamUrl: "https://live.radio-suton.de/listen/zabavna_80/radio.mp3",
    genre: "zabavna",
    description: "Zabavna muzika 80-tih godina",
    artwork: "https://app.radio-suton.de/stream-artwork/zabavna_80.jpg",
    isActive: true,
    bitrate: 192,
    location: "Germany",
    color: "#003560",
  },
  {
    id: "eotvatx62zgywrxtaaciwxx4",
    name: "Suton Radio - 90-te Narodna",
    streamUrl: "https://live.radio-suton.de/listen/narodna_90/radio.mp3",
    genre: "narodna",
    description: "Narodna muzika 90-tih godina",
    artwork: "https://app.radio-suton.de/stream-artwork/narodna_90.jpg",
    isActive: true,
    bitrate: 192,
    location: "Germany",
    color: "#04DDCF",
  },
  {
    id: "geflhx98qw94w1k9cidll164",
    name: "Suton Radio - 90-te Zabavna",
    streamUrl: "https://live.radio-suton.de/listen/zabavna_90/radio.mp3",
    genre: "zabavna",
    description: "Zabavna muzika 90-tih godina",
    artwork: "https://app.radio-suton.de/stream-artwork/zabavna_90.jpg",
    isActive: true,
    bitrate: 192,
    location: "Germany",
    color: "#F29E39",
  },
  {
    id: "oejvcelenx1f9z3jgcrmpk5j",
    name: "Suton Radio - Boemi",
    streamUrl: "https://live.radio-suton.de/listen/boemi/radio.mp3",
    genre: "boemi",
    description: "Boemska muzika i kafanske pjesme",
    artwork: "https://app.radio-suton.de/stream-artwork/boemi.jpg",
    isActive: true,
    bitrate: 192,
    location: "Germany",
    color: "#15475B",
  },
  {
    id: "w9a974sdomqh8mste2li8ay8",
    name: "Suton Radio - Kids",
    streamUrl: "https://live.radio-suton.de/listen/kids/radio.mp3",
    genre: "djecja",
    description: "Dječja muzika",
    artwork: "https://app.radio-suton.de/stream-artwork/kids.jpg",
    isActive: true,
    bitrate: 192,
    location: "Germany",
    color: "#1EB5F5",
  },
  {
    id: "j6e0qzzaa6j0rco8o8koktgm",
    name: "Suton Radio - Love",
    streamUrl: "https://live.radio-suton.de/listen/love/radio.mp3",
    genre: "ljubavna",
    description: "Ljubavne pjesme",
    artwork: "https://app.radio-suton.de/stream-artwork/love.jpg",
    isActive: true,
    bitrate: 192,
    location: "Germany",
    color: "#750E31",
  },
  {
    id: "bolqm4hj719wikqtq9th01fm",
    name: "Suton Radio - Balade",
    streamUrl: "https://live.radio-suton.de/listen/balade/radio.mp3",
    genre: "balade",
    description: "Balade sa Balkana",
    artwork: "https://app.radio-suton.de/stream-artwork/balade.jpg",
    isActive: true,
    bitrate: 192,
    location: "Germany",
    color: "#9F4E3A",
  },
  {
    id: "o5iognwe7kyo5qcc62ofcive",
    name: "Suton Radio - POP",
    streamUrl: "https://live.radio-suton.de/listen/pop/radio.mp3",
    genre: "pop",
    description: "Pop muzika",
    artwork: "https://app.radio-suton.de/stream-artwork/pop.jpg",
    isActive: true,
    bitrate: 192,
    location: "Germany",
    color: "#F55C15",
  },
  {
    id: "x7dq2zz28shb76fsar73p4ug",
    name: "Suton Radio - MIX",
    streamUrl: "https://live.radio-suton.de/listen/mix/radio.mp3",
    genre: "mix",
    description: "Mix svih žanrova",
    artwork: "https://app.radio-suton.de/stream-artwork/mix.jpg",
    isActive: true,
    bitrate: 192,
    location: "Germany",
    color: "#9A1471",
  },
  {
    id: "cyubg5kl166rj8iydfa59u9l",
    name: "Suton Radio - ROCK",
    streamUrl: "https://live.radio-suton.de/listen/rock/radio.mp3",
    genre: "rock",
    description: "Rock muzika",
    artwork: "https://app.radio-suton.de/stream-artwork/rock.jpg",
    isActive: true,
    bitrate: 192,
    location: "Germany",
    color: "#36010F",
  },
  {
    id: "jhme0q1m0xwrstk5316mwa65",
    name: "Suton Radio - Dance",
    streamUrl: "https://live.radio-suton.de/listen/dance/radio.mp3",
    genre: "dance",
    description: "Dance muzika",
    artwork: "https://app.radio-suton.de/stream-artwork/dance.jpg",
    isActive: true,
    bitrate: 192,
    location: "Germany",
    color: "#1425AF",
  },
  {
    id: "vummi0nbjq33uz96ssz0irl6",
    name: "Suton Radio - EX-YU Evergreen",
    streamUrl: "https://live.radio-suton.de/listen/exyu_evergreen/radio.mp3",
    genre: "exyu",
    description: "EX-YU evergreen klasici",
    artwork: "https://app.radio-suton.de/stream-artwork/exyu_evergreen.jpg",
    isActive: true,
    bitrate: 192,
    location: "Germany",
    color: "#306D3A",
  },
  {
    id: "wsvhq8kf2bh363if0gky3por",
    name: "Suton Radio - Hrvatske",
    streamUrl: "https://live.radio-suton.de/listen/exyu/radio.mp3",
    genre: "mix",
    description: "Hrvatska muzika",
    artwork: "https://app.radio-suton.de/stream-artwork/exyu.jpg",
    isActive: true,
    bitrate: 192,
    location: "Germany",
    color: "#3D4C60",
  },
  {
    id: "u8djwtvwykx06x2b3kzwn1na",
    name: "Suton Radio - Cafe",
    streamUrl: "https://live.radio-suton.de/listen/cafe/radio.mp3",
    genre: "cafe",
    description: "Kafe muzika za opuštanje",
    artwork: "https://app.radio-suton.de/stream-artwork/cafe.jpg",
    isActive: true,
    bitrate: 192,
    location: "Germany",
    color: "#F39B26",
  },
  {
    id: "f3x5iyrlwez8b5urryloplpz",
    name: "Suton Radio - Trending",
    streamUrl: "https://live.radio-suton.de/listen/trending/radio.mp3",
    genre: "trending",
    description: "Trending hitovi",
    artwork: "https://app.radio-suton.de/stream-artwork/trending.jpg",
    isActive: true,
    bitrate: 192,
    location: "Germany",
    color: "#BE2EAB",
  },
  {
    id: "wzqk8wqvbf1epp7ujk3cs7p9",
    name: "Suton Radio - Narodne pre 80",
    streamUrl: "https://live.radio-suton.de/listen/narodne_pre80/radio.mp3",
    genre: "narodna",
    description: "Narodne pjesme prije 80-tih",
    artwork: "https://app.radio-suton.de/stream-artwork/narodne_pre80.jpg",
    isActive: true,
    bitrate: 192,
    location: "Germany",
    color: "#A46527",
  },
  {
    id: "c1mag0ctfziu6e9eixo19a0a",
    name: "Suton Radio - Zabavne pre 80",
    streamUrl: "https://live.radio-suton.de/listen/zabavne_pre80/radio.mp3",
    genre: "zabavna",
    description: "Zabavne pjesme prije 80-tih",
    artwork: "https://app.radio-suton.de/stream-artwork/zabavne_pre80.jpg",
    isActive: true,
    bitrate: 192,
    location: "Germany",
    color: "#FDC648",
  },
  {
    id: "le7658oly8ehsn3uxo5badk8",
    name: "Suton Radio - Moderno Narodna",
    streamUrl: "https://live.radio-suton.de/listen/moderno_narodna/radio.mp3",
    genre: "narodna",
    description: "Moderna narodna muzika",
    artwork: "https://app.radio-suton.de/stream-artwork/moderno_narodna.jpg",
    isActive: true,
    bitrate: 192,
    location: "Germany",
    color: "#AE1FA6",
  },
  {
    id: "mzldfzw4uhkptph9yguvbhmu",
    name: "Suton Radio - Moderno Zabavna",
    streamUrl: "https://live.radio-suton.de/listen/moderno_zabavna/radio.mp3",
    genre: "zabavna",
    description: "Moderna zabavna muzika",
    artwork: "https://app.radio-suton.de/stream-artwork/moderno_zabavna.jpg",
    isActive: true,
    bitrate: 192,
    location: "Germany",
    color: "#2570CD",
  },
  {
    id: "ocbsvms1s8031rnputrsmoe0",
    name: "Suton Radio - Trap 'N Rap",
    streamUrl: "https://live.radio-suton.de/listen/trap_rap/radio.mp3",
    genre: "trap_rap",
    description: "Trap i Rap muzika",
    artwork: "https://app.radio-suton.de/stream-artwork/trap_rap.jpg",
    isActive: true,
    bitrate: 192,
    location: "Germany",
    color: "#220347",
  },
  {
    id: "y6dn8izrjqbmqqfqj8dr0d1j",
    name: "Suton Radio - Narodne od 80-tih",
    streamUrl: "https://live.radio-suton.de/listen/narodne_od80/radio.mp3",
    genre: "narodna",
    description: "Narodne pjesme od 80-tih do danas",
    artwork: "https://app.radio-suton.de/stream-artwork/narodne_od80.jpg",
    isActive: true,
    bitrate: 192,
    location: "Germany",
    color: "#DDBEA9",
  },
  {
    id: "w9a74rhy89nyzypvmos0f5s4",
    name: "Suton Radio - Zabavne od 80-tih",
    streamUrl: "https://live.radio-suton.de/listen/zabavne_od80/radio.mp3",
    genre: "zabavna",
    description: "Zabavne pjesme od 80-tih do danas",
    artwork: "https://app.radio-suton.de/stream-artwork/zabavne_od80.jpg",
    isActive: true,
    bitrate: 192,
    location: "Germany",
    color: "#6E0240",
  },
  {
    id: "vknciiu6di8yusxt2yk1330j",
    name: "Suton Radio - Instrumental",
    streamUrl: "https://live.radio-suton.de/listen/instrumental/radio.mp3",
    genre: "instrumental",
    description: "Instrumentalna muzika",
    artwork: "https://app.radio-suton.de/stream-artwork/instrumental.jpg",
    isActive: true,
    bitrate: 192,
    location: "Germany",
    color: "#052043",
  },
  {
    id: "lz32g2xp0ri62idi7nutoir7",
    name: "Suton Radio - Vlaška",
    streamUrl: "https://live.radio-suton.de/listen/vlaska/radio.mp3",
    genre: "vlaska",
    description: "Vlaška muzika",
    artwork: "https://app.radio-suton.de/stream-artwork/vlaska.jpg",
    isActive: true,
    bitrate: 192,
    location: "Germany",
    color: "#D5A66F",
  },
  {
    id: "sufqmxwqqkolpdcxny6p4gh6",
    name: "Suton Radio - Vlaška Kola",
    streamUrl: "https://live.radio-suton.de/listen/vlaska_kola/radio.mp3",
    genre: "kola",
    description: "Vlaška kola",
    artwork: "https://app.radio-suton.de/stream-artwork/vlaska_kola.jpg",
    isActive: true,
    bitrate: 192,
    location: "Germany",
    color: "#DFB474",
  },
  {
    id: "dif2ojvdc3dsvx5z4tvpbwag",
    name: "Suton Radio - Srpska Kola",
    streamUrl: "https://live.radio-suton.de/listen/srpska_kola/radio.mp3",
    genre: "kola",
    description: "Srpska kola",
    artwork: "https://app.radio-suton.de/stream-artwork/srpska_kola.jpg",
    isActive: true,
    bitrate: 192,
    location: "Germany",
    color: "#70261C",
  },
  {
    id: "s2s8ekycy22208xtqe0odsmd",
    name: "Suton Radio - Trubači",
    streamUrl: "https://live.radio-suton.de/listen/trubaci/radio.mp3",
    genre: "trubaci",
    description: "Trubači - dueta i orkestri",
    artwork: "https://app.radio-suton.de/stream-artwork/trubaci.jpg",
    isActive: true,
    bitrate: 192,
    location: "Germany",
    color: "#F9CB78",
  },
  {
    id: "i39b0q9qg092eumqj75bp71t",
    name: "Suton Radio - Tamburaši",
    streamUrl: "https://live.radio-suton.de/listen/tamburasi/radio.mp3",
    genre: "tamburasi",
    description: "Tamburaška muzika",
    artwork: "https://app.radio-suton.de/stream-artwork/tamburasi.jpg",
    isActive: true,
    bitrate: 192,
    location: "Germany",
    color: "#A15C21",
  },
  {
    id: "s4j0b8sgtwpr1k3awb1zobv9",
    name: "Suton Radio - Starogradske",
    streamUrl: "https://live.radio-suton.de/listen/starogradske/radio.mp3",
    genre: "starogradske",
    description: "Starogradske pjesme",
    artwork: "https://app.radio-suton.de/stream-artwork/starogradske.jpg",
    isActive: true,
    bitrate: 192,
    location: "Germany",
    color: "#118AB2",
  },
  {
    id: "w35v375fb262ijldke6h88d2",
    name: "Suton Radio - Sevdalinke",
    streamUrl: "https://live.radio-suton.de/listen/sevdelinke/radio.mp3",
    genre: "sevdah",
    description: "Sevdalinke - bosanska tradicija",
    artwork: "https://app.radio-suton.de/stream-artwork/sevdelinke.jpg",
    isActive: true,
    bitrate: 192,
    location: "Germany",
    color: "#F18F22",
  },
  {
    id: "gjl1sf43ciqidkd6sf47zt3q",
    name: "Suton Radio - Crnogorske",
    streamUrl: "https://live.radio-suton.de/listen/crnogorske/radio.mp3",
    genre: "crnogorska",
    description: "Crnogorska muzika",
    artwork: "https://app.radio-suton.de/stream-artwork/crnogorske.jpg",
    isActive: true,
    bitrate: 192,
    location: "Germany",
    color: "#B99471",
  },
  {
    id: "ld5hjm79frocmxyt019iz3kf",
    name: "Suton Radio - Gusle",
    streamUrl: "https://live.radio-suton.de/listen/gusle/radio.mp3",
    genre: "gusle",
    description: "Guslarska muzika",
    artwork: "https://app.radio-suton.de/stream-artwork/gusle.jpg",
    isActive: true,
    bitrate: 192,
    location: "Germany",
    color: "#734521",
  },
  {
    id: "wf89x8fix65rsrgdob2sxxdk",
    name: "Suton Radio - Makedonske",
    streamUrl: "https://live.radio-suton.de/listen/makedonske/radio.mp3",
    genre: "makedonska",
    description: "Makedonska muzika",
    artwork: "https://app.radio-suton.de/stream-artwork/makedonske.jpg",
    isActive: true,
    bitrate: 192,
    location: "Germany",
    color: "#A10401",
  },
  {
    id: "yi6a6aewa218llz9mlnu211y",
    name: "Suton Radio - Rumunske Narodne",
    streamUrl: "https://live.radio-suton.de/listen/rumunske_narodne/radio.mp3",
    genre: "rumunska",
    description: "Rumunske narodne pjesme",
    artwork: "https://app.radio-suton.de/stream-artwork/rumunske_narodne.jpg",
    isActive: true,
    bitrate: 192,
    location: "Germany",
    color: "#0030A1",
  },
  {
    id: "ifkhkrtzf3fnwm4grgwow2m4",
    name: "Suton Radio - Rumunske Zabavne",
    streamUrl: "https://live.radio-suton.de/listen/rumunske_zabavne/radio.mp3",
    genre: "rumunska",
    description: "Rumunske zabavne pjesme",
    artwork: "https://app.radio-suton.de/stream-artwork/rumunske_zabavne.jpg",
    isActive: true,
    bitrate: 192,
    location: "Germany",
    color: "#F9CF87",
  },
  {
    id: "xun1lm2iqhr1l1wpkcesaqqi",
    name: "Suton Radio - Romske",
    streamUrl: "https://live.radio-suton.de/listen/romske/radio.mp3",
    genre: "romska",
    description: "Romska muzika",
    artwork: "https://app.radio-suton.de/stream-artwork/romske.jpg",
    isActive: true,
    bitrate: 192,
    location: "Germany",
    color: "#740B09",
  },
  {
    id: "c5yt3515vyv05467coulicbl",
    name: "Suton Radio - Grčke",
    streamUrl: "https://live.radio-suton.de/listen/grcke/radio.mp3",
    genre: "grcka",
    description: "Grčka muzika",
    artwork: "https://app.radio-suton.de/stream-artwork/grcke.jpg",
    isActive: true,
    bitrate: 192,
    location: "Germany",
    color: "#0347F7",
  },
  {
    id: "er0ubbp3m9ecl5dlv8yf6a64",
    name: "Suton Radio - AI Songs",
    streamUrl: "https://live.radio-suton.de/listen/ai_songs/radio.mp3",
    genre: "ai",
    description: "AI generisane pjesme",
    artwork: "https://app.radio-suton.de/stream-artwork/ai_songs.jpg",
    isActive: true,
    bitrate: 192,
    location: "Germany",
    color: "#BB2A9F",
  },
];

export const STATIONS_LKG_KEY = 'suton-stations-lkg';

const LEGACY_STREAM_RE =
  /zeno\.fm|streamupsolutions|balkanmusic|radios3|banovina|dzungla|morava|bigfm|pink\.rs/i;

export function isLegacyTestStation(
  station: { streamUrl?: string } | null | undefined
): boolean {
  return Boolean(station?.streamUrl && LEGACY_STREAM_RE.test(station.streamUrl));
}

export function loadStationsLkg(): RadioStation[] | null {
  try {
    const raw = localStorage.getItem(STATIONS_LKG_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    if (!Array.isArray(parsed) || parsed.length === 0) return null;
    return parsed as RadioStation[];
  } catch {
    return null;
  }
}

export function saveStationsLkg(stations: RadioStation[]): void {
  if (!stations?.length) return;
  try {
    localStorage.setItem(STATIONS_LKG_KEY, JSON.stringify(stations));
  } catch {
    /* quota / private mode */
  }
}

/** Prvi fallback pri startu: LKG keš → hardcoded STATIONS. */
export function getInitialStations(): RadioStation[] {
  return loadStationsLkg() ?? STATIONS;
}

export const DEFAULT_LIVE_STATION: RadioStation =
  STATIONS.find((s) => s.streamUrl?.includes('suton_radio')) ?? STATIONS[0];

export const GENRES = [
  { id: 'all', name: 'Sve' },
  { id: 'mix', name: 'Mix' },
  { id: 'narodna', name: 'Narodna' },
  { id: 'zabavna', name: 'Zabavna' },
  { id: 'pop', name: 'Pop' },
  { id: 'rock', name: 'Rock' },
  { id: 'folk', name: 'Folk' },
] as const;
